export enum BrowserEnum {
    'chrome.exe' = 'Chrome',
    'msedge.exe' = 'Microsoft Edge',
    '360chrome.exe' = '360Chrome',
    '360se.exe' = '360se',
    'sesvr.exe' = '360se',
    'SeAppService.exe' = '360se',
    '360ChromeX.exe' = '360chromeX',
    'QQBrowser.exe' = 'QQ 浏览器',
    'QQBrowserLiveup.exe' = 'QQ 浏览器',
    'SogouExplorer.exe' = '搜狗浏览器',
    '2345Explorer.exe' = '2345 加速浏览器',
    'crashpad_helper.exe' = '2345 加速浏览器',
    'Protect_2345Explorer.exe' = '2345 加速浏览器',
    'Maxthon.exe' = '极速浏览器',
    'brave.exe' = 'Brave',
    'opera.exe' = 'Opera',
    'opera_crashreporter.exe' = 'Opera',
    'browser_assistant.exe' = 'Opera',
    'vivaldi.exe' = 'Vivaldi',
    'firefox.exe' = 'Firefox',
    'CocCocCrashHandler.exe' = 'CocCoc',
    'CocCocCrashHandler64.exe' = 'CocCoc',
    'ChromeCoreLiveup.exe' = 'ChromeCore',
}